import { useState } from "react";
import { Button } from "../ui/button";
import { toaster } from "../ui/toaster";
import { BiTrash } from "react-icons/bi";
import { useWebHelper } from "@viabl/echo-web-client-core";
import { Dialog, Text, useDisclosure, Portal, CloseButton, DialogActionTrigger, DialogBody, DialogCloseTrigger, DialogFooter, DialogPositioner, Input } from '@chakra-ui/react';
import { IBundle } from "../../pages/echoRoleBundles";
import { DialogBackdrop, DialogContent, DialogHeader, DialogRoot, DialogTitle, DialogTrigger } from "../ui/dialog";

interface newUserProps {
    cb: Function,
    existingBundle: IBundle,
}

export default function BundleDelete(props: newUserProps) {
    const { onOpen, onClose } = useDisclosure();
    const [open, setOpen] = useState<boolean>(false);
    const [input, setInput] = useState<string>("");
    const [errors, setErrors] = useState<{ [key: string]: string }>({});

    const webHelpers = useWebHelper();

    const handleClickOpen = () => {
        onOpen();
        setOpen(true);
        setInput("")
        setErrors({})
    }

    const handleClick = () => {
        if (input != props.existingBundle.name) {
            toaster.create({
                title: `Incorrect Name Entered`,
                type: "error",
            })
            return
        }

        webHelpers.GetAsync("/api/rolebundles", "auth").then((data) => {
            console.log(data)

            const exists =
                Array.isArray(data) &&
                data.some(
                    (item: { parent_id: IBundle["parent_id"] }) =>
                        item.parent_id === props.existingBundle.id
                )

            console.log(exists)
            if (exists) {
                toaster.create({
                    title: `Cannot delete bundle with children`,
                    type: "error",
                })
                return
            }
            webHelpers.DeleteNoResultAsync("/api/rolebundle/" + props.existingBundle.id, "auth").then(() => {
                handleClose()
                props.cb()

                toaster.create({
                    title: `Deleted Bundle`,
                    type: "success",
                })
            })
        })
    }

    const handleClose = () => {
        setOpen(false);
        onClose();
    }

    return (
        <>
            <DialogRoot
                open={open}
                aria-describedby="alert-dialog-slide-description"
                size={{ base: "md", "2xl": "sm" }}
            >
                <Dialog.Backdrop />
                <DialogTrigger>
                    <Button bg={"AbleBlue"} color={"white"} _hover={{ bg: "AbleYellow", color: "white" }} size={"sm"} onClick={handleClickOpen}><BiTrash size={"10px"} />Delete</Button>
                </DialogTrigger>
                <DialogContent marginTop={"0px"} marginBottom={"0px"}>
                    <DialogTitle>Delete Bundle</DialogTitle>
                    <DialogBody padding={"10px"}>
                        <Text py={5}>Are you sure you want to delete this bundle?</Text>
                        <Text pb={4}>Please enter the name of the bundle to delete: </Text>
                        <Input placeholder="Name (Case Senstive)" value={input} onChange={(e) => setInput(e.currentTarget.value)}></Input>
                    </DialogBody>
                    <DialogFooter>
                        <Button onClick={handleClick}
                            disabled={false}
                            bg={"AbleBlue"}
                            color={"white"}
                            _hover={{ color: "AbleYellow" }}>Delete</Button>
                        <DialogTrigger>
                            <Button onClick={handleClose} colorScheme="red" marginLeft={"10px"}>Cancel</Button>
                        </DialogTrigger>
                    </DialogFooter>
                </DialogContent>
            </DialogRoot>
        </>
    );
}